export let PusherEvent = /*#__PURE__*/function (PusherEvent) {
  PusherEvent["InvoiceEvent"] = "invoice-event";
  PusherEvent["MailboxUpdated"] = "mailbox-updated";
  PusherEvent["KYCStatusUpdated"] = "kyc-status-updated";
  PusherEvent["PaymentMethod"] = "payment-method";
  PusherEvent["VendorBankAccountConnected"] = "vendor-bank-account";
  PusherEvent["BillingEvent"] = "billing-event";
  PusherEvent["IntegrationEvent"] = "integration-event";
  PusherEvent["ContactUpdated"] = "contact-updated";
  return PusherEvent;
}({});

/** Pusher event for channel_name=<businessId>, eventName='invoice-event'. */

export let InvoiceEventType = /*#__PURE__*/function (InvoiceEventType) {
  InvoiceEventType["InvoiceIssued"] = "invoiceIssued";
  InvoiceEventType["QboInvoiceUpdated"] = "qboInvoiceUpdated";
  InvoiceEventType["XeroInvoiceUpdated"] = "xeroInvoiceUpdated";
  return InvoiceEventType;
}({});
export let BillEventType = /*#__PURE__*/function (BillEventType) {
  BillEventType["CsvBulkBillFinished"] = "csvBulkBillFinished";
  return BillEventType;
}({});

/** Pusher event for channel_name=<businessId>, eventName='payment-method'. */

/** Pusher event for channel_name=<businessId>, eventName='vendor-bank-account'. */

export let PaymentMethodEventType = /*#__PURE__*/function (PaymentMethodEventType) {
  PaymentMethodEventType["PaymentMethodAdded"] = "paymentMethodAdded";
  PaymentMethodEventType["PaymentMethodUpdated"] = "paymentMethodUpdated";
  PaymentMethodEventType["FailedToAddPaymentMethod"] = "failedToAddPaymentMethod";
  PaymentMethodEventType["VendorBankAccountConnected"] = "vendorBankAccountConnected";
  return PaymentMethodEventType;
}({});
export let IntegrationEventType = /*#__PURE__*/function (IntegrationEventType) {
  IntegrationEventType["IntegrationXeroReady"] = "integrationXeroReady";
  return IntegrationEventType;
}({});
export let ContactUpdatedType = /*#__PURE__*/function (ContactUpdatedType) {
  ContactUpdatedType["ContactEmailUpdated"] = "contactEmailUpdated";
  return ContactUpdatedType;
}({});